//ESTADO DEL PRECIO (NEGOCIO):
export const priceState = {
    '-1': '--',
    0: '--',
    1: 'Idea',
    2: 'Precio',
    3: 'Pausado',
    4: 'Retirado',
    5: 'Inactivo'
}